import { ScrollArea } from '@journ/ui/scroll-area'
import { useIntlayer } from 'react-intlayer'
import type { TopicView } from '../domain/chat'
import { ConversationRow } from './conversation-row'

type ConversationListProps = {
	topics: TopicView[]
	activeTopicId: string | null
	onSelect: (id: string) => void
}

// The conversation sidebar: client-side title search over the polled topic list.
const ConversationList = ({ topics, activeTopicId, onSelect }: ConversationListProps) => {
	const content = useIntlayer('chat')

	return (
		<ScrollArea className='flex-1'>
			{topics.length === 0 ? (
				<div className='px-4 py-8 text-center'>
					<p className='text-sm text-muted-foreground'>{content.noConversations}</p>
				</div>
			) : (
				<div className='flex flex-col p-2'>
					{topics.map(topic => (
						<ConversationRow
							key={topic.id}
							topic={topic}
							active={topic.id === activeTopicId}
							fallbackTitle={content.unnamed.value}
							onSelect={onSelect}
						/>
					))}
				</div>
			)}
		</ScrollArea>
	)
}

export { ConversationList }
